import { render } from "./CUser.vue?vue&type=template&id=5af1ee9b"
import script from "./CUser.vue?vue&type=script&lang=js"
export * from "./CUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__